import React from 'react';
import Tooltip from "@material-ui/core/Tooltip";
import {withStyles} from "@material-ui/styles";


const CustomTooltip = withStyles((theme) => ({
    tooltip: {
        backgroundColor: '#f5f5f9',
        color: 'rgba(0, 0, 0, 0.87)',
        maxWidth: 220,
        fontSize: theme.typography.pxToRem(12),
        border: '1px solid #dadde9',
    },
}))(Tooltip);

export const InfoTooltip = ({children, text, placement}) => {
    return <>
        <CustomTooltip title={text} placement={placement}>
            {children}
        </CustomTooltip>
    </>
}